<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [canGoBack]="true"
      [title]="pro?.homekeeper?.name"
      [customBack]="customBackPage"
      [showDropdownMenu]="true"
      [dropdownMenu]="proDropdownMenu" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>


    @if (errorMessage) {
      <tidy-error-message
        [text]="errorMessage" />
    }

    @if (!pro?.is_private) {
      <tidy-row [align]="'center'">
        <tidy-text
          [body]="pro?.availability" />
      </tidy-row>
    }

    <tidy-card>
      @if (!isProLoaded) {
        <tidy-row>
          <ion-skeleton-text animated style="width: 100%; height: 13px; border-radius: 6px;" />
        </tidy-row>
      }
      @if (isProLoaded) {
        <tidy-row class="vertical-align-center">
          <div>
            <tidy-initials-icon
              [fullName]="pro?.homekeeper?.name" />
            <tidy-text
              [header]="pro?.homekeeper?.name"
              [translate]="false" />
            @if (pro?.homekeeper?.state === 'pending') {
              <tidy-text
                style="margin-left: 5px"
                [body]="'Edit'"
                (action)="goToEditContactInfo()"
                class="link" />
            }
          </div>
        </tidy-row>
      }
      @if (!isProsDataLoaded) {
        <tidy-card-button [hideArrow]="true">
          <ion-skeleton-text animated style="width: 100%; height: 13px" />
        </tidy-card-button>
      }
      @if (isProsDataLoaded) {
        @if (!isCurrentProBlocked) {
          <tidy-card-button (action)="goToBookJob()">
            <tidy-row class="vertical-align-center">
              <tidy-image
                [src]="'assets/img/book.svg'"
                [class]="body-size" />
              <tidy-text
                body="Add Job" />
            </tidy-row>
          </tidy-card-button>
        }
        @if (assignedPropertiesCount > 0) {
          <tidy-card-button (action)="goToPropertiesList()">
            <tidy-row class="vertical-align-center">
              <tidy-image
                [src]="'assets/img/home.svg'"
                class="body-size" />
              <tidy-text
                [body]="assignedPropertiesLabel" />
              <tidy-image
                [src]="'assets/img/information-circle-grey.svg'"
                class="small-body-size"
                style="margin-left: 5px"
                [matTooltip]="assignedPropertiesSentence | translate" />
            </tidy-row>
          </tidy-card-button>
        }
        @if (isCurrentProBlocked) {
          <tidy-card-button (action)="approveAndUnblockProConfirmation()">
            <tidy-row class="vertical-align-center">
              <tidy-image
                [src]="'assets/img/checkmark.svg'"
                class="body-size" />
              <tidy-text
                body="Approve & Unblock" />
            </tidy-row>
          </tidy-card-button>
        }
      }
    </tidy-card>

    <tidy-card>
      <tidy-card-button (action)="goToMessageThreadPage()" class="arrow-to-top" [hideArrow]="!isMessagesLoaded">
        <tidy-row class="vertical-align-center extra-bottom-padding">
          <tidy-image
            [src]="'assets/img/message.svg'"
            class="header-size" />
          <tidy-text
            [header]="'Messages'" />
        </tidy-row>
        @if (isMessagesLoaded) {
          <tidy-row>
            @if (messages?.length === 0) {
              <tidy-text
                [body]="'No Messages'" />
            }
            @if (messages?.length > 0) {
              <tidy-text
                [body]="messages[messages?.length - 1]?.from_member?.first_name + ':'" /><span>&nbsp;</span>
                <tidy-text
                  [body]="messages[messages?.length - 1]?.content?.text" />
              }
            </tidy-row>
          }
          @if (!isMessagesLoaded) {
            <tidy-row>
              <ion-skeleton-text animated style="width: 100%; height: 13px" />
              <ion-skeleton-text animated style="width: 40%; height: 13px" />
            </tidy-row>
          }
        </tidy-card-button>
      </tidy-card>

      @if (pro?.is_private) {
        <tidy-card>
          <tidy-row [alignLastItemRight]="true">
            <tidy-image
              [src]="'assets/img/dollar.svg'"
              class="header-size" />
            <tidy-text
              [header]="'Balance'" />
            @if (!isBillingsDataLoaded) {
              <ion-skeleton-text animated style="height: 13px; border-radius: 6px; margin-left: 270px;" />
            }
            @if (isBillingsDataLoaded) {
              <tidy-text
                [body]="creditBalance?.credit_balance | tcurrency" />
            }
          </tidy-row>
          @if (!isBillingsDataLoaded) {
            <tidy-card-button [hideArrow]="true">
              <ion-skeleton-text animated style="width: 100%; height: 13px" />
            </tidy-card-button>
            <tidy-card-button [hideArrow]="true">
              <ion-skeleton-text animated style="width: 100%; height: 13px" />
            </tidy-card-button>
          }
          @if (isBillingsDataLoaded) {
            @if (pro?.is_private) {
              <tidy-card-button (action)="goToSendPayment()">
                <tidy-row class="vertical-align-center">
                  <tidy-image
                    [src]="'assets/img/salary.svg'"
                    [class]="body-size" />
                  <tidy-text
                    body="Send Payment" />
                </tidy-row>
              </tidy-card-button>
            }
            @if (pro?.is_private && userRole !== 'member') {
              <tidy-card-button (action)="goToProBillingHistoryPage()">
                <tidy-row class="vertical-align-center">
                  <tidy-image
                    [src]="'assets/img/more-history.svg'"
                    [class]="body-size" />
                  <tidy-text
                    body="Billing History" />
                </tidy-row>
              </tidy-card-button>
            }
          }
        </tidy-card>
      }

      @if (pro?.is_private) {
        <tidy-card>
          <tidy-row class="vertical-align-center extra-bottom-padding">
            <tidy-image
              [src]="'assets/img/invoice.svg'"
              class="header-size" />
            <tidy-text
              [header]="'Bills'" />
          </tidy-row>
          @if (!isBillingsDataLoaded) {
            <tidy-row style="padding-top: 1rem;">
              <ion-skeleton-text animated style="width: 100%; height: 13px; border-radius: 6px;" />
            </tidy-row>
          }
          @if (isBillingsDataLoaded) {
            @for (invoice of pendingInvoices; track invoice) {
              <tidy-card-button (action)="goToInvoicePage(invoice)">
                <tidy-row class="vertical-align-center">
                  <tidy-image
                    [src]="'assets/img/alert.svg'"
                    [class]="body-size" />
                  <tidy-text
                    [body]="invoice?.amount | tcurrency" /><span>&nbsp;</span>
                    <tidy-text
                      [body]="'total for'" /><span>&nbsp;</span>
                      <tidy-text
                        [body]="invoice?.items[0]?.service_details?.date | parseDateTime: 'MMM d'" /><span>&nbsp;</span>
                        <tidy-text
                          [body]="'job'" />
                      </tidy-row>
                    </tidy-card-button>
                  }
                  @if (pendingInvoices?.length >= 10) {
                    <tidy-card-button (action)="goToBillsPage()">
                      <tidy-row class="vertical-align-center">
                        <tidy-image
                          [src]="'assets/img/alert.svg'"
                          [class]="body-size" />
                        <tidy-text
                          body="View More" />
                      </tidy-row>
                    </tidy-card-button>
                  }
                  @if (pendingInvoices?.length == 0) {
                    <tidy-row>
                      <tidy-text
                        [body]="pendingInvoices?.length" /><span>&nbsp;</span>
                        <tidy-text
                          [body]="'Pending'" />
                      </tidy-row>
                    }
                  }
                </tidy-card>
              }

              <tidy-card>
                <tidy-row class="vertical-align-center extra-bottom-padding">
                  <tidy-image
                    [src]="'assets/img/paper-plane.svg'"
                    class="header-size" />
                  <tidy-text
                    [header]="'Proposals'" />
                </tidy-row>
                @if (!isBillingsDataLoaded) {
                  <tidy-row style="padding-top: 1rem;">
                    <ion-skeleton-text animated style="width: 100%; height: 13px; border-radius: 6px;" />
                  </tidy-row>
                }
                @if (isBillingsDataLoaded) {
                  @for (proposal of pendingProposals; track proposal) {
                    <tidy-card-button (action)="goToProposalPage(proposal)">
                      <tidy-row class="vertical-align-center">
                        <tidy-image
                          [src]="'assets/img/alert.svg'"
                          [class]="body-size" />
                        <tidy-text
                          [body]="proposal?.proposable?.team_service?.name | titlecase" />
                      </tidy-row>
                    </tidy-card-button>
                  }
                  @if (pendingProposals?.length == 0) {
                    <tidy-row>
                      <tidy-text
                        [body]="pendingProposals?.length" /><span>&nbsp;</span>
                        <tidy-text
                          [body]="'Pending'" />
                      </tidy-row>
                    }
                  }
                </tidy-card>

                @if (checkNotEmpty(pastJobs)) {
                  <tidy-row>
                    <tidy-text
                      [header]="'Past Jobs'" />
                  </tidy-row>
                }

                @if (isPastJobsLoaded) {
                  @if (pastJobs?.length === 0) {
                    <tidy-alert>
                      <tidy-row>
                        <tidy-text
                          [body]="'No Past jobs'" />
                      </tidy-row>
                    </tidy-alert>
                  }
                  @if (checkNotEmpty(pastJobs)) {
                    @for (job of pastJobs; track job) {
                      <tidy-card>
                        @if (job?.cleaning_id) {
                          <tidy-card-button (action)="goToPastJob(job?.cleaning_id, job?.is_private)">
                            @if (job?.service) {
                              <tidy-row>
                                <tidy-text
                                  [body]="job?.service" />
                                @if (job?.start_datetime_local) {
                                  <tidy-text
                                    [body]="(' on ' | translate) + (job?.start_datetime_local | parseDateTime: 'ddd MMM d') + ' ' + (job?.start_datetime_local | parseDateTime: 'h:mma')" />
                                }
                              </tidy-row>
                            }
                            @if (job?.display_address) {
                              <tidy-row>
                                <tidy-text
                                  [helper]="job?.display_address" />
                              </tidy-row>
                            }
                          </tidy-card-button>
                        }
                      </tidy-card>
                    }
                  }
                }

                @if (!isPastJobsLoaded) {
                  <tidy-row class="extra-bottom-padding">
                    <ion-skeleton-text animated style="width: 100%; height: 75px; border-radius: 6px;" />
                  </tidy-row>
                  <tidy-row class="extra-bottom-padding">
                    <ion-skeleton-text animated style="width: 100%; height: 75px; border-radius: 6px;" />
                  </tidy-row>
                  <tidy-row class="extra-bottom-padding">
                    <ion-skeleton-text animated style="width: 100%; height: 75px; border-radius: 6px;" />
                  </tidy-row>
                  <tidy-row class="extra-bottom-padding">
                    <ion-skeleton-text animated style="width: 100%; height: 75px; border-radius: 6px;" />
                  </tidy-row>
                  <tidy-row class="extra-bottom-padding">
                    <ion-skeleton-text animated style="width: 100%; height: 75px; border-radius: 6px;" />
                  </tidy-row>
                }
              </tidy-wrapper>
            </ng-template>

            @if (!isRightSideContent) {
              <app-scroll-wrapper [templateContent]="content" />
            }

            @if (isRightSideContent) {
              <ion-content class="ion-content-right-column">
                <ng-container *ngTemplateOutlet="content" />
              </ion-content>
            }
